import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { WorkItem } from '../work-item'
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { ScheduleSelectRouteTableComponent } from '../schedule-select-route-table/schedule-select-route-table.component'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton, MatButton } from '@angular/material/button'
import { ElderThemeDirective } from '@elderbyte/ngx-starter'
import { MatToolbar } from '@angular/material/toolbar'

export interface IRouteSelectDialogSingleOptions {
  readonly item: WorkItem
}

@Component({
  selector: 'app-schedule-select-dialog-single',
  templateUrl: './schedule-select-dialog-single.component.html',
  styleUrls: ['./schedule-select-dialog-single.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatButton,
    ScheduleSelectRouteTableComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ScheduleSelectDialogSingleComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly selectedItems$ = new BehaviorSubject<WorkItem[]>([])
  public readonly showAllRoutes$ = new BehaviorSubject<boolean>(false)
  dialogRef = inject<MatDialogRef<ScheduleSelectDialogSingleComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IRouteSelectDialogSingleOptions>(MAT_DIALOG_DATA)
    this.selectedItems$.next([data.item])
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get showAllProdRoutes(): boolean {
    return this.showAllRoutes$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onShowAllRoutesChange(): void {
    this.showAllRoutes$.next(!this.showAllRoutes$.getValue())
  }

  public onItemsModified(itemIds: string[]): void {
    if (itemIds && itemIds.length > 0) {
      this.dialogRef.close(itemIds[0])
    }
  }
}
